// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"301e2f82","658":"049ba402"}[chunkId] + ".chunk.css";
};